export const SEARCH_BY_NAME_OPEN_PARAM = 'open_search_by_name';

// Must stay in sync with backend edge-ngram min_gram; fewer chars is a guaranteed empty result.
export const MIN_NAME_LENGTH = 2;
// Soft cap on the input — guards against pathological queries being interpolated
// into headings and SR announcements, and keeps URLs reasonable.
export const MAX_NAME_LENGTH = 80;
